import { useState } from "react";

import { Banner, Button } from "../../../shared/ui";
import { useAccessT } from "./useAccessT";

/**
 * Shown when a mutation answers step_up_required. The action ends the operator
 * session and starts the sign-in; the pending change is not kept.
 */
export function StepUpNotice({
  onReauthenticate,
  onCancel,
}: {
  onReauthenticate: () => Promise<void>;
  onCancel: () => void;
}) {
  const t = useAccessT();
  const [busy, setBusy] = useState(false);
  return (
    <div className="flex flex-col gap-3">
      <Banner tone="warning" title={t("admin.access.stepUp.title")}>
        {t("admin.access.stepUp.body")} {t("admin.access.stepUp.discarded")}
      </Banner>
      <div className="flex flex-wrap justify-end gap-2.5">
        <Button variant="ghost" onClick={onCancel}>
          {t("admin.access.reason.cancel")}
        </Button>
        <Button
          variant="primary"
          disabled={busy}
          onClick={() => {
            setBusy(true);
            void onReauthenticate();
          }}
        >
          {t("admin.access.stepUp.action")}
        </Button>
      </div>
    </div>
  );
}
